export const ApiPre = '/api/v1/'
export const PageSize = 10
export const PageSizes = [10, 15, 20, 50, 100, 200, 500]
export const PublicPath = '/user'
export const StaticDomain = 'http://localhost:3000'
